import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { AuthService } from '../../admin/auth.service';
import { CandidatoService } from '../../candidato/candidato.service';
import { CfcService } from '../../cfc/cfc.service';
import { Util } from '../../shared/util';

@Component({
  templateUrl: './solicitar-curso-pratico.component.html',
})
export class SolicitarCursoPraticoComponent extends WebPage implements OnInit {

  idCandidato;
  candidato;
  cfcsUnidades;

  constructor(
    private route: ActivatedRoute, private router: Router,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private authService: AuthService,
    private candidatoService: CandidatoService, private cfcService: CfcService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.candidatoService.getFull(this.idCandidato)
      .finally(() => this.isLoading = false)
      .subscribe(
        candidato => {
          this.candidato = candidato;

          this.isLoading = true;
          this.cfcService.getCfcUnidadesByUnidade(candidato.idUnidade)
            .finally(() => this.isLoading = false)
            .subscribe(
              cfcsUnidades => {
                // console.log(cfcsUnidades);
                this.cfcsUnidades =
                cfcsUnidades.filter(x =>
                  x.statusCredenciamento.idStatusCredenciamento.toLowerCase() === 'f7abbafc-57d2-4bbf-8739-8873e868b18a').slice();
              },
              error => this.gerenciaErro(error)
            );
        },
        error => this.gerenciaErro(error)
      );
  }

  gerarGuia(idCfc) {
    if (Util.isNullOrEmptyOrUndefined(idCfc)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Prestador de serviço não selecionado!' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja emitir a guia de encaminhamento para este aluno?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        const usuario = this.authService.informacoesUsuario();
        this.candidatoService.encaminharCursoPratico(this.idCandidato, idCfc, usuario.Nome);

        window.setTimeout(
          () => this.router.navigate(['/curso-pratico/gerenciar/' + this.idCandidato]),
          2000
        );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.router.navigate(['/curso-pratico/gerenciar/' + this.idCandidato]);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cursoPratico/solicitar-curso-pratico/solicitar-curso-pratico.component.ts